import React from "react";
import { Box, Typography } from "@mui/material";
import { getStyles } from "./Results.styles";

const Results = () => {
  const styles = getStyles();

  return (
    <Box sx={styles.pastResultsContainer}>
      <Box sx={styles.pastResultsSection}>
        <Typography variant="h2" component="h2">
          Ce s-a întâmplat la edițiile anterioare
        </Typography>

        <Box sx={styles.pastResultsStatsContainer}>
          <Box sx={styles.pastResultsStats}>
            <Typography variant="h4" component="h4">
              126
            </Typography>
            <Typography variant="body1" component="p">
              școli dotate
            </Typography>
          </Box>
          <Box sx={styles.pastResultsStats}>
            <Typography variant="h4" component="h4">
              46.000
            </Typography>
            <Typography variant="body1" component="p">
              copii susținuți
            </Typography>
          </Box>
          <Box sx={styles.pastResultsStats}>
            <Typography variant="h4" component="h4">
              78.000
            </Typography>
            <Typography variant="body1" component="p">
              cărți donate
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.pastResultsImage}>
          <img
            src="/assets/images/girl-reading.svg"
            alt="girl-reading-illustration"
          />
          <img src="/assets/images/books.svg" alt="books-illustration" />
        </Box>
      </Box>
    </Box>
  );
};

export default Results;
